import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';
import { breakpoints } from 'styles/breakpoints';

export const StyledCandivoreBundle = styled.div`
  width: 100%;
  max-width: 400px;
  height: 175px;
  aspect-ratio: 1/1.31;
  position: relative;
  font-family: var(--font-family), Arial;
  font-weight: bold;

  .container {
    width: 100%;
    height: 100%;
    max-height: 175px; // safari fix
    display: flex;
    flex-direction: column;
    border-radius: ${(props: any) => `${props.borderRadius || 7}px`};
    background: ${(props: any) =>
      createGradientOrSolid(props.bundleBorderColor)};

    .ac-ribbon-badge.ac-ribbon-badge--center {
      width: 100%;
      position: absolute;
      height: 16px;
      bottom: 36px;

      .ac-ribbon-badge__front {
        justify-content: center;
        &__text {
          display: flex !important;
          font-size: 12px;
        }
      }
    }

    .badge-wrapper {
      max-height: 18px;
      min-height: calc(15% - 4px);
      position: absolute;
      width: 100%;
      top: 1px;
      height: 14px;

      .middle-badge {
        top: -3px;
        width: 100%;
        padding: 0 5px;
        display: flex;
        align-items: center !important;
        justify-content: center;

        & > p {
          font-size: 12px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          margin-bottom: 2px;
        }
      }
    }

    .product {
      height: 100%;
      display: flex;
      flex-direction: column;
      padding: 1px 1px 0 1px;
      border-top-left-radius: ${(props: any) => `${props.borderRadius || 7}px`};
      border-top-right-radius: ${(props: any) =>
        `${props.borderRadius || 7}px`};
      background: ${(props: any) =>
        props.backgroundSrc
          ? `url("${props.backgroundSrc}")`
          : createGradientOrSolid(props.backgroundColor)};
      background-clip: content-box;
      background-size: cover;
      gap: 0;
    }

    .price {
      height: 100%;
      max-height: 38px;
      border-bottom-left-radius: ${(props: any) =>
        `${props.borderRadius || 7}px`};
      border-bottom-right-radius: ${(props: any) =>
        `${props.borderRadius || 7}px`};
      margin-top: auto;
      position: relative;
      overflow: hidden;

      &:after {
        content: '';
        height: 4px;
        width: 100%;
        background: rgba(0, 0, 0, 0.4);
        position: absolute;
        bottom: 0;
      }

      .totalPrice .final-price {
        text-shadow: 0 1px 1px #000;
      }
    }
  }

  @media (min-width: 800px) {
    .container {
      .ac-ribbon-badge.ac-ribbon-badge--center {
        bottom: 36px;

        .ac-ribbon-badge__front {
          height: 18px;
          &__text {
            font-size: 14px;
          }
        }

        .ribbon-edge.ribbon-edge-left {
          top: 18px;
        }

        .ribbon-edge.ribbon-edge-right {
          top: 18px;
        }
      }

      .badge-wrapper {
        .middle-badge {
          & > p {
            font-size: 14px;
          }
        }
      }
    }
  }
` as any;
